(() => {
  const grid = document.querySelector('[data-favorites-grid]');
  if (!grid) return;

  const storageKey = window.RAGStudioFavorites?.storageKey || 'ragstudio_favorites';
  const emptyMessage = grid.dataset.emptyMessage || 'No favorites yet.';

  const getHandles = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  };

  const setHandles = (handles) => {
    const favorites = Array.from(new Set(handles.filter(Boolean)));
    localStorage.setItem(storageKey, JSON.stringify(favorites));
    document.dispatchEvent(new CustomEvent('ragstudio:favorites:change', { detail: { favorites } }));
  };

  const escapeHtml = (value = '') =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    const currency = window.Shopify?.currency?.active || 'EUR';
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency });
  };

  const renderEmpty = () => {
    grid.innerHTML = `
      <div class="favorites-page__empty">
        <p>${escapeHtml(emptyMessage)}</p>
        <a class="button" href="/collections/all">Ver produtos</a>
      </div>
    `;
  };

  const renderProduct = (product) => {
    const image = product.featured_image
      ? `<img src="${product.featured_image}" alt="${escapeHtml(product.title)}" loading="lazy">`
      : '';

    return `
      <article class="favorites-page__item" data-favorite-item data-product-handle="${escapeHtml(product.handle)}">
        <button class="favorites-page__remove" type="button" data-favorite-remove="${escapeHtml(product.handle)}" aria-label="Remover ${escapeHtml(product.title)} dos favoritos">
          <svg viewBox="0 0 18 18" focusable="false" aria-hidden="true">
            <path d="m4.5 4.5 9 9M13.5 4.5l-9 9"/>
          </svg>
        </button>
        <a href="${product.url}" class="favorites-page__media">${image}</a>
        <div class="favorites-page__content">
          <h2 class="favorites-page__title"><a href="${product.url}">${escapeHtml(product.title)}</a></h2>
          <p class="favorites-page__price">${formatMoney(product.price)}</p>
          <a class="favorites-page__link" href="${product.url}">Ver produto</a>
        </div>
      </article>
    `;
  };

  const render = () => {
    const handles = getHandles();
    if (!handles.length) {
      renderEmpty();
      return;
    }

    grid.setAttribute('aria-busy', 'true');

    Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      )
    ).then((products) => {
      const validProducts = products.filter(Boolean);
      const validHandles = validProducts.map((product) => product.handle);
      if (validHandles.length !== handles.length) setHandles(validHandles);

      grid.removeAttribute('aria-busy');
      grid.innerHTML = validProducts.length ? validProducts.map(renderProduct).join('') : '';
      if (!validProducts.length) renderEmpty();
    });
  };

  grid.addEventListener('click', (event) => {
    const button = event.target.closest('[data-favorite-remove]');
    if (!button) return;

    const handle = button.dataset.favoriteRemove;
    const nextHandles = getHandles().filter((favoriteHandle) => favoriteHandle !== handle);
    setHandles(nextHandles);
    button.closest('[data-favorite-item]')?.remove();

    if (!nextHandles.length) renderEmpty();
  });

  document.addEventListener('ragstudio:favorites:change', (event) => {
    const activeElement = document.activeElement;
    if (activeElement?.matches('[data-favorite-remove]')) return;
    if (event.detail?.favorites) render();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) render();
  });

  render();
})();
